import {composeReducers, createReducerFunction} from 'immer-reducer'
import defaultState from 'redux/speedBump/state'
import SpeedBump from 'redux/speedBump/speedBump.duck'

export default composeReducers(
  createReducerFunction(SpeedBump, defaultState)
)
